import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
const tokenid = localStorage.getItem("tokenid");
const schoolId = localStorage.getItem('schoolId');



export const getPatternListSvc = (callback) => {
    // console.log("getPatternList called");
    var obj = { status: "Success", message: "" }
    axios({
        // url: httpUrlLocal + '/pattern/' + schoolId + '/all',
        url: 'http://localhost:8288/pattern/' + schoolId + '/all',
        method: "GET",
        // headers: { 'tokenid': tokenid },
        // withCredentials: true,
    }).then((response) => {
        // console.log('response in getPatternList', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstPattern = response.data.lstQpPattern;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const getPatternDtlsSvc = (patternId, callback) => {
    // console.log("getPatternDtls called, patternId", patternId);
    var obj = { status: "Success", message: "" }
    axios({
        url: 'http://localhost:8288/pattern/' + schoolId + '/' + patternId,
        method: "GET",
        // headers: { 'tokenid': tokenid },
        // withCredentials: true,
    }).then((response) => {
        // console.log('response in getPatternDtls', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.patternDtls = response.data.pattern;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const getQuestionTypeListSvc = (callback) => {
    // console.log("getQuestionTypeListSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: "http://localhost:8288/qus_type/all",
        method: "GET",
        // headers: { 'tokenid': tokenid },
        // withCredentials: true,
    }).then((response) => {
        // console.log('response in getQuestionTypeListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstQusType = response.data.lstQusType;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const saveQpPatternSvc = (patternObj, callback) => {
    // console.log("saveQpPatternSvc called");
    let obj = { status: "Success", message: "" }
    axios({
        url: "http://localhost:8288/pattern/" + schoolId + "/new",
        method: "POST",
        data: JSON.stringify(patternObj),
        headers: {
            "Content-Type": "application/json",
            // 'tokenid': tokenid 
        },
        // withCredentials: true,
    }).then((response) => {
        // console.log('response in saveQpPatternSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const editQpPatternSvc = (patternObj, callback) => {
    // console.log("editQpPatternSvc called");
    let obj = { status: "Success", message: "" }
    axios({
        url: "http://localhost:8288/pattern/" + schoolId + "/new",
        method: "POST",
        data: JSON.stringify(patternObj),
        headers: {
            "Content-Type": "application/json",
            // 'tokenid': tokenid 
        },
        // withCredentials: true,
    }).then((response) => {
        // console.log('response in editQpPatternSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}

